import { type ReactNode } from 'react';

export const InputLabel = ({ children }: { children: ReactNode }) => {
  if (!children) {
    return null;
  }

  return <span className='mb-1 block font-normal'>{children}</span>;
};
